// export const gobalSetting = addressMap[gethost];
const $carzoneapi = {
  version: function () {
    const isAndriod = /android/gi.test(window?.navigator?.appVersion)
    const isIphone = /iPad|iphone|iOS/gi.test(window?.navigator?.userAgent)
    const ua = window?.navigator?.userAgent.toLowerCase()
    const isweixin = /MicroMessenger/gi.test(ua)
    // @ts-ignore
    const isweapp = window?.__wxjs_environment === 'miniprogram' || false
    const isWxwork = /wxwork/i.test(ua)
    return {
      isandriod: isAndriod && isweixin === false,
      isios: isIphone && isweixin === false,
      isweixin,
      isweapp,
      isWxwork
    }
  },
  wrmoible: function (funname, data, weixin) {
    if ($carzoneapi.version().isandriod && $carzoneapi.isValid()) {
      if (data !== undefined) {
        return window?.MobileFunction?.hasOwnProperty(funname) && window?.MobileFunction[funname](JSON.stringify(data))
      }
      // window?.MobileFunction[funname]();
      return window?.MobileFunction?.hasOwnProperty(funname) && window?.MobileFunction[funname]()
    }
    if ($carzoneapi.version().isios && $carzoneapi?.isValid()) {
      return window?.webkit?.messageHandlers[funname]?.postMessage(data)
    }
    if ($carzoneapi.version().isweixin && weixin !== undefined) {
      return weixin()
    }
    if ($carzoneapi.version().isweapp) {
      return window.history.back()
    }
  },
  getmobile: function () {
    if ($carzoneapi.version().isandriod) {
      return window?.MobileFunction
    }
    if ($carzoneapi.version().isios) {
      return window
    }
    return null
  },
  getapppage: function (funname, data) {
    if ($carzoneapi.version().isandriod) {
        // eslint-disable-next-line no-unused-expressions
        window?.MobileFunction[funname]()
    } else if ($carzoneapi.version().isios) {
      // eslint-disable-next-line no-unused-expressions
        window?.webkit?.messageHandlers[funname].postMessage(data)
    }
  },
  openWin: function (data) {
    $carzoneapi.wrmoible('openWin', data)
  },
  closeWin: function (data) {
    $carzoneapi.wrmoible('closeWin', data)
  },
  // 关闭页面容器
  closePage: function () {
    $carzoneapi.wrmoible('closePage')
  },
  // 跳转购物车页面
  toCart: function () {
    $carzoneapi.wrmoible('navigate', {
      url: 'czbu://page/flutter/shoppingcart/list'
    })
  },
  // 显示/隐藏原生头部
  hideTopBar: function () {
    try {
      $carzoneapi.wrmoible('hideTopBar')
    } catch (e) {
      console.log(e)
    }
  },
  // 跳转到首页
  toHome: function () {
    $carzoneapi.wrmoible('toHome')
  },
  closeToWin: function (data) {
    if (data.aname !== undefined) {
      if ($carzoneapi.version().isandriod) Object.assign(data, { name: data.aname })
      else if ($carzoneapi.version().isios) Object.assign(data, { name: data.iname })
    }
    $carzoneapi.wrmoible('closeToWin', data)
  },
  pageParam: function () {
    if ($carzoneapi.version().isios) {
      return window?.pageParam
    }
    if ($carzoneapi.version().isandriod) {
      return JSON.parse(window?.MobileFunction?.pageParam())
    }
    return null
  },
  isValid: function () {
    return !!window?.MobileFunction || (window?.webkit && window?.webkit?.messageHandlers && window?.webkit?.messageHandlers?.toLogin)
  },
  showProjectSignPay: function () {}
}
const getAppFunc = (funname) => {
  return $carzoneapi.getmobile() && $carzoneapi.getmobile()[funname] && $carzoneapi.getmobile()[funname]()
}
const scanCode = () => {
  return new Promise((resolve) => {
    window.returnScanCodeResult = (result) => {
      resolve(result.scanCodeResult)
    }
    $carzoneapi.wrmoible('scanCode')
  })
}
export {
  $carzoneapi,
  getAppFunc,
  scanCode

}
